import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    is_submit_btn_disable: false,
    autocomplete_items: [],
    params: { id: null, intent_id: null }
  },
  mutations: {
    INIT_TRAIN_QUESTION_TOPIC_DIALOG(state, payload) {
      state.visibility = true
      state.params.id = payload
    },
    RESET_TRAIN_QUESTION_TOPIC_DIALOG(state) {
      state.visibility = false
      state.params = { id: null, intent_id: null }
      state.autocomplete_items = []
    },
    SET_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    },
    SET_TRAIN_QUESTION_TOPIC_DIALOG_AUTOCOMPLETE_ITEMS(state, payload) {
      state.autocomplete_items = payload
    },
    SET_TRAIN_QUESTION_TOPIC_DIALOG_INTENT_ID(state, payload) {
      state.params.intent_id = payload
    }
  },
  actions: {
    async fetchExistingTopicList({ commit }, payload) {
      try {
        const response = await api.getQuestionTopicList({ search: payload })
        if (response.data.success) {
          commit('SET_TRAIN_QUESTION_TOPIC_DIALOG_AUTOCOMPLETE_ITEMS', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },

    async trainExistingQuestionTopic({ state, commit }) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__General.question_topic')),
          loading: true
        })
        commit('SET_IS_SUBMIT_BTN_DISABLE', true)
        const response = await api.trainIntent({ params: state.params })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
          commit('RESET_TRAIN_QUESTION_TOPIC_DIALOG')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
